require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./decorator"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./decorator"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./decorator")) : factory(root["./utils"], root["./decorator"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__86__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[58],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@-moz-document url-prefix(){.glass.highcontrast .ba-common-svgIcon{fill:currentColor !important}}.ba-common-svgIcon{color:inherit;fill:currentColor;box-sizing:content-box !important;pointer-events:auto}.ba-common-svgIcon.is-tiny{width:12px;height:12px}.ba-common-svgIcon.is-small{width:16px;height:16px}.ba-common-svgIcon.is-normal{width:24px;height:24px}.ba-common-svgIcon.is-large{width:32px;height:32px}.ba-common-svgIcon.is-xlarge{width:64px;height:64px}.ba-common-svgIcon.is-xxlarge{width:128px;height:128px}.ba-common-svgIcon.is-12{width:12px;height:12px}.ba-common-svgIcon.is-16{width:16px;height:16px}.ba-common-svgIcon.is-24{width:24px;height:24px}.ba-common-svgIcon.is-32{width:32px;height:32px}.ba-common-svgIcon.is-64{width:64px;height:64px}.ba-common-svgIcon.is-128{width:128px;height:128px}.ba-common-svgIcon.is-pad{padding:8px}.ba-common-svgIcon.is-clickable{cursor:pointer}.ba-common-svgIcon:not(.is-clickable){pointer-events:none}[dir=rtl] .ba-common-svgIcon.is-bidi{transform:scaleX(-1)}.ba-common-svgIcon:focus{outline:none}.svgIcon-page-display{width:100px;margin:16px 0;height:10px;display:inline-block}.svgIcon-page-display .ba-common-svgIcon.is-pad{background-clip:content-box;box-shadow:inset 0 0 0 8px #393939;box-shadow:inset 0 0 0 8px var(--interactive-02, #393939)}.ba-common-svgIcon{transition-timing-function:cubic-bezier(0.2, 0, 0.38, 0.9)}.ba-common-svgIcon.is-focus{outline:2px solid;outline-color:#a8c0f3}.ba-common-svgIcon.is-intent_primary{fill:#161616}.ba-common-svgIcon.is-intent_positive{fill:#24a148}.ba-common-svgIcon.is-intent_warning{fill:#f1c21b}.ba-common-svgIcon.is-intent_danger{fill:#da1e28}.ba-common-svgIcon.is-intent_info{fill:#0043ce}.is-disabled{fill:#c6c6c6}", ""]);

// exports
exports.locals = {
	"svgIconClassName": "\"ba-common-svgIcon\""
};

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(511);


/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

exports.__esModule = true;

var _SVGIcon = _interopRequireWildcard(__webpack_require__(512));

exports.default = _SVGIcon.default;
exports.SVGIcon = _SVGIcon.default;
exports.SVGIconDecoration = _SVGIcon.SVGIconDecoration;
exports.createIcon = _SVGIcon.createIcon;

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.createIcon = createIcon;
exports.SVGIconDecoration = exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _decorator = _interopRequireWildcard(__webpack_require__(86));

var _SVGIcon = _interopRequireDefault(__webpack_require__(513));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const svgIconClassName = _SVGIcon.default.svgIconClassName.replace(/"/g, '');

const {
  sanitize,
  BaPropTypes
} = _utils.propsUtils;

class SVGIcon extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "state", {
      showFocusClass: false
    });
    (0, _defineProperty2.default)(this, "_isIconObject", () => {
      const {
        icon
      } = this.props;
      return typeof icon === 'object' && icon !== null;
    });
    (0, _defineProperty2.default)(this, "_onKeyUp", e => {
      this.props.onKeyUp && this.props.onKeyUp(e);

      if (e.keyCode === 9) {
        this.setState({
          showFocusClass: true
        });
      }
    });
    (0, _defineProperty2.default)(this, "_onBlur", e => {
      this.props.onBlur && this.props.onBlur(e);
      this.setState({
        showFocusClass: false
      });
    });
  }

  render() {
    const {
      className,
      iconId: _iconId,
      icon,
      height,
      width,
      rotate,
      size,
      pad,
      intent,
      children,
      focusable,
      themable,
      ariaLabelledby,
      ariaDescribedby,
      alt,
      desc,
      style,
      bidi,
      disabled,
      verticalAlign,
      ...other
    } = this.props;
    const iconId = _iconId || (typeof icon === 'string' ? icon : _utils.lodash.get(icon, 'id', ''));
    let styles;

    if (height > 0 && width > 0) {
      styles = {
        height,
        width
      };
    }

    if (rotate) {
      if (!styles) {
        styles = {};
      }

      styles.WebkitTransform = `rotate(${rotate}deg)`;
      styles.transform = `rotate(${rotate}deg)`;
    }

    styles = { ...styles,
      verticalAlign,
      ...style
    };
    const hasA11yTitle = ariaLabelledby !== undefined && ariaLabelledby !== null;
    const hasA11yDesc = ariaDescribedby !== undefined && ariaDescribedby !== null;
    const isA11y = hasA11yTitle || hasA11yDesc;
    const clickable = isA11y || other.onClick || other.onMouseDown || other.onMouseUp || other.onMouseOver || other.onMouseOut || other.onMouseLeave || other.onMouseEnter;
    const classNames = (0, _utils.classnames)(svgIconClassName, {
      [size]: !this._isIconObject(),
      [`intent_${intent}`]: intent && !themable,
      pad,
      clickable,
      focus: this.state.showFocusClass,
      bidi,
      disabled
    });
    const a11yProps = isA11y ? {
      role: 'img',
      'aria-labelledby': `${hasA11yTitle ? ariaLabelledby : ''} ${hasA11yDesc ? ariaDescribedby : ''}`
    } : '';
    const dimension = {};

    if (this._isIconObject()) {
      const [sWidth, sHeight] = this.props.icon.viewBox.split(' ').splice(-2);
      dimension.width = sWidth;
      dimension.height = sHeight;
    }

    const svg = /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
      focusable: `${focusable}`
    }, sanitize(other), {
      className: `${classNames} ${className}`
    }, dimension, {
      style: styles,
      onKeyUp: this._onKeyUp,
      onBlur: this._onBlur
    }, a11yProps), hasA11yTitle ? /*#__PURE__*/_react.default.createElement("title", {
      id: ariaLabelledby
    }, alt) : '', hasA11yDesc ? /*#__PURE__*/_react.default.createElement("desc", {
      id: ariaDescribedby
    }, desc) : '', /*#__PURE__*/_react.default.createElement("use", {
      className: themable ? 'ba-graphics-themable' : '',
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      xlinkHref: `#${iconId}`
    }));

    if (children) {
      // if (children.type.name === 'Flyout') {
      //     return (
      //         <span>
      //             { svg }
      //             <Decorator style={{ position: 'absolute' }}>
      //                 { children }
      //             </Decorator>
      //         </span>
      //     );
      // }
      return /*#__PURE__*/_react.default.createElement(_decorator.default, null, svg, children);
    }

    return svg;
  }

}

exports.default = SVGIcon;
(0, _defineProperty2.default)(SVGIcon, "propTypes", {
  className: _propTypes.default.string,

  /** Either iconId or icon is required customPropTypes: [string, Object] */
  iconId: BaPropTypes.requiredIf(_propTypes.default.oneOfType([_propTypes.default.string]), props => !Object.prototype.hasOwnProperty.call(props, 'icon')),

  /** One of <icon.id> or <ba-graphics icon object> customPropTypes: [string, Object] */
  icon: BaPropTypes.requiredIf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]), props => !Object.prototype.hasOwnProperty.call(props, 'iconId')),
  children: _propTypes.default.node,
  disabled: _propTypes.default.bool,
  focusable: _propTypes.default.bool,
  height: _propTypes.default.number,
  width: _propTypes.default.number,
  rotate: _propTypes.default.number,
  size: _propTypes.default.oneOf(['tiny', 'small', 'normal', 'large', 'xlarge', 'xxlarge']),
  intent: _propTypes.default.oneOf(['', 'primary', 'positive', 'danger', 'warning', 'info']),
  themable: _propTypes.default.bool,
  pad: _propTypes.default.bool,
  ariaLabelledby: _propTypes.default.string,
  ariaDescribedby: _propTypes.default.string,
  alt: _propTypes.default.string,
  desc: _propTypes.default.string,
  style: _propTypes.default.object,
  bidi: _propTypes.default.bool,
  onKeyUp: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  verticalAlign: _propTypes.default.oneOf(['baseline', 'top', 'middle', 'bottom', 'sub', 'text-top', 'unset', 'inherit', 'initial']),
  onClick: _propTypes.default.func
});
(0, _defineProperty2.default)(SVGIcon, "defaultProps", {
  verticalAlign: 'bottom',
  size: 'small',
  focusable: false,
  className: '',
  style: {},
  bidi: false
});

class SVGIconDecoration extends _react.Component {
  render() {
    const {
      location,
      x,
      y,
      ...other
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_decorator.Decoration, {
      location: location,
      x: x,
      y: y
    }, /*#__PURE__*/_react.default.createElement(SVGIcon, (0, _extends2.default)({
      size: "small"
    }, other)));
  }

}

exports.SVGIconDecoration = SVGIconDecoration;
(0, _defineProperty2.default)(SVGIconDecoration, "propTypes", {
  location: _decorator.Decoration.propTypes.location,
  x: _decorator.Decoration.propTypes.x,
  y: _decorator.Decoration.propTypes.y
});

function createIcon(icon, size, componetClassName, locationClass, props) {
  if (!icon) {
    return null;
  } // if we have a react component pass it through otherwise SVGIcon will now handle icon.id(string) or icon(object)


  const iconComponent = _react.default.isValidElement(icon) ? props ? _react.default.cloneElement(icon, props) : icon : /*#__PURE__*/_react.default.createElement(SVGIcon, (0, _extends2.default)({}, size ? {
    size
  } : {}, {
    focusable: false,
    icon: icon
  }, props));
  return locationClass ? /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _utils.classnames)(`${componetClassName}__icon`, locationClass)
  }, iconComponent) : iconComponent;
}

/***/ }),

/***/ 513:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_SVGIcon_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(150);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_SVGIcon_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_SVGIcon_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_SVGIcon_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_SVGIcon_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__86__;

/***/ })

},[[510,0]]]);
});